import React from "react";

const MenuItems = (props) => {
  const { title, children, onClick, active } = props;
  return (
    <div className={`headerUI ${active ? "open" : ""}`}>
      <button
        className="defaultButton text-nowrap dropdown navItem heading"
        onClick={onClick}
      >
        {title}
        <i className="astm-icon fas fa-caret-right"></i>
      </button>
      <div className="submenuMainContainerMenu">{children}</div>
    </div>
  );
};

export default MenuItems;
